














































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Hogar from "@/models/hogar/hogar.model";
import Direccion from "@/models/direccion.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import { Utils } from "@/core/Utils";
import NameValue from "@/models/nameValue.model";
import TipoTramite from "@/models/tipoTramite";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";
import TramiteLiberacion from "@/models/tramite/liberacion-sancion-observacion/index.model";
import {
  HogarSancion,
  HogarObservacion
} from "../../models/hogar/alertas.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import Helpers from "@/helpers/helper";
import moment from "moment";
import TramiteLiberacionDocumento from "../../models/tramite/liberacion-sancion-observacion/documento.model";

@Component({
  components: {
    DatePickerComponent
  }
})
export default class SolicitudLiberacionSacionObservacion extends BaseVue {
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly content!: TramiteBeneficiario;

  model = new TramiteLiberacion();
  razon = new NameValue();
  sacionTable: BTableConfig<HogarSancion> = new BTableConfig<HogarSancion>();
  observacionTable: BTableConfig<HogarObservacion> = new BTableConfig<
    HogarObservacion
  >();
  razonSancionObservacion: any = Utils.newGUID();
  created() {
    this.$emit("render", []);
    this.setupTableSancion();
    this.setupTableObservacion();
  }
  destroyed() {
    if (this.content) {
      let contenido = this.content as any;
      if (contenido && contenido.tramiteLiberacion)
        delete contenido.tramiteLiberacion;
      this.$emit("update:content", contenido);
    }
  }

  get generaCambioDireccion() {
    return this.razon.codigo === "RealizoUnCambioDeDireccion";
  }
  get personaId() {
    if (this.beneficiario && this.beneficiario.personaId)
      return this.beneficiario.personaId;
    if (this.solicitante && this.solicitante.id) return this.solicitante.id;
    return 0;
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId) {
      return this.beneficiario.hogarId;
    }
    return 0;
  }
  get tipoTramiteId() {
    if (this.tipoTramite && this.tipoTramite.id) {
      return this.tipoTramite.id;
    }
    return 0;
  }
  setupTableSancion() {
    this.sacionTable.controller = "hogarsancion";
    this.sacionTable.whereParams = this.getWhereParamsSancion();
    this.sacionTable.activeActions = false;
    this.sacionTable.enableDefaultColumns = false;
    this.sacionTable.selectable = true;
    this.sacionTable.selection.change = this.onSelectSancion;
    this.formatColumnsSancion();
  }
  onSelectSancion(row: HogarSancion, old: HogarSancion) {
    this.razonSancionObservacion = "RAZON_LIBERACION_SANCION";
    this.model.observacionId = undefined;
    delete this.observacionTable.selection.selected;
    this.model.sancionId = row.id;
  }
  getWhereParamsSancion() {
    let result = [];
    result.push(`Estado != "Levantada"`);
    if (this.hogarId) result.push(`hogarId="${this.hogarId}"`);
    return result.join("&");
  }
  formatColumnsSancion() {
    let causaSancion = new BTableColumn("causaSancion", "Categoría",false);
    let mes = new BTableColumn("mes", "Mes",false);
    mes.type = BTableColumnType.Custom;
    mes.customFilter = (value: string) => Helpers.Filters.NumAMes(value);
    let ano = new BTableColumn("ano", "Año",false);
    let vigencia = new BTableColumn("vigencia", "Vigencia",false);
    vigencia.type = BTableColumnType.Custom;
    vigencia.customFilter = (val: any) =>
      val === 1 ? `${val} mes` : `${val} meses`;
    let fecha = new BTableColumn("fecha", "Fecha",false);
    fecha.type = BTableColumnType.Date;
    this.sacionTable.insertColumns(
      causaSancion,
      mes,
      ano,
      vigencia,
      fecha
    );
  }

  setupTableObservacion() {
    this.observacionTable.controller = "hogarobservacion";
    this.observacionTable.whereParams = this.getWhereParamsObservacion();
    this.observacionTable.activeActions = false;
    this.observacionTable.enableDefaultColumns = false;
    this.observacionTable.selectable = true;
    this.observacionTable.selection.change = this.onSelectObservacion;
    this.formatColumnsObservacion();
  }
  onSelectObservacion(row: HogarObservacion, old: HogarObservacion) {
    this.razonSancionObservacion = "RAZON_LIBERACION_OBSERVACION";
    this.model.sancionId = undefined;
    delete this.sacionTable.selection.selected;
    this.model.observacionId = row.id;
  }
  getWhereParamsObservacion() {
    let result = [];
    result.push(`FechaObservacion!=null`);
    result.push(`(FechaLiberacion=null || FechaLiberacion>DateTime.Now)`);
    if (this.hogarId) result.push(`hogarId="${this.hogarId}"`);
    return result.join("&");
  }
  formatColumnsObservacion() {
    let causaObservacion = new BTableColumn("causaObservacion", "Causa",false);
    let estado = new BTableColumn("estado", "Estado",false);
    let institucion = new BTableColumn("institucion", "Institución",false);
    let fechaObservacion = new BTableColumn("fechaObservacion", "Fecha",false);
    fechaObservacion.type = BTableColumnType.Date;
    this.observacionTable.insertColumns(
      causaObservacion,
      estado,
      institucion,
      fechaObservacion
    );
  }
  getFormatDate(fecha: any) {
    return `DateTime.Parse("${moment(fecha).format()}")`;
  }
  @Watch("model", { deep: true })
  set(model: TramiteLiberacion) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.tramiteLiberacion = this.map<TramiteLiberacion>(model);
      contenido.tramiteLiberacion.tipoTramiteId = this.tipoTramite.id;
      contenido.tramiteLiberacion.tituloTipoTramite = this.tipoTramite.nombre;
      contenido.tramiteLiberacion.codigoTipoTramite = this.tipoTramite.codigo;
      contenido.tramiteLiberacion.generaCambioDireccion = this.generaCambioDireccion;
      if (!this.generaCambioDireccion)
        contenido.tramiteLiberacion.tramiteCambioDireccion = null;

      this.$emit("update:content", contenido);
    }
  }
  onChangeDocs(tipos: any, docs: any[]) {
    this.model.documentos = docs.map(x => {
      let doc = new TramiteLiberacionDocumento();
      doc.personaId = this.personaId;
      doc.documentoId = x.documentoId;
      doc.documento = x.documento;
      doc.tipoDocumentoId = x.tipoDocumentoId;
      doc.tipoDocumentoNombre = x.tipoDocumentoNombre;
      return doc;
    });
  }
  hogar = new Hogar();
  repoHogar = new BaseRepository<Hogar>("hogar");
  @Watch("beneficiario", { immediate: true, deep: true })
  async onBeneficiarioChange(value: Beneficiario) {
    if (value && value.id) {
      this.sacionTable.whereParams = this.getWhereParamsSancion();
      this.observacionTable.whereParams = this.getWhereParamsObservacion();

      if (this.sacionTable.reload) this.sacionTable.reload();
      if (this.observacionTable.reload) this.observacionTable.reload();
      this.hogar =
        (await this.repoHogar.one(`id=${value.hogarId}`)) || new Hogar();
    }
  }

  public async isValid() {
    let isValid = await this.validateCurrentValidator();
    if (!isValid) return false;

    return this.validateRefCollection("documentos");
  }
}
